/**
 * Scroll lock utility that prevents body scroll without jumping.
 * Uses event prevention instead of CSS changes to avoid breaking sticky positioning.
 */

let isLocked = false;
let scrollableEl = null;

function preventScroll(e) {
  // Allow scrolling inside the menu (or any element with data-scroll-allow)
  if (scrollableEl && scrollableEl.contains(e.target)) {
    // Check if the scrollable element can scroll in the direction of the event
    const el = scrollableEl;
    const isAtTop = el.scrollTop <= 0;
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;

    // For wheel events
    if (e.type === "wheel") {
      const scrollingUp = e.deltaY < 0;
      const scrollingDown = e.deltaY > 0;

      // Only prevent if at boundary and trying to scroll past it
      if ((isAtTop && scrollingUp) || (isAtBottom && scrollingDown)) {
        e.preventDefault();
      }
      return; // Allow normal scroll within menu
    }

    // For touch events, allow scrolling within menu
    return;
  }

  e.preventDefault();
}

function preventTouchMove(e) {
  if (scrollableEl && scrollableEl.contains(e.target)) {
    return; // Allow touch scroll within menu
  }
  e.preventDefault();
}

export function lockScroll(menuElement = null) {
  if (isLocked) return;
  isLocked = true;
  scrollableEl = menuElement;

  document.addEventListener("wheel", preventScroll, { passive: false });
  document.addEventListener("touchmove", preventTouchMove, { passive: false });
  document.documentElement.classList.add("menu-open");
}

export function unlockScroll() {
  if (!isLocked) return;
  isLocked = false;
  scrollableEl = null;

  document.removeEventListener("wheel", preventScroll);
  document.removeEventListener("touchmove", preventTouchMove);
  document.documentElement.classList.remove("menu-open");
}

export function toggleScrollLock(lock, menuElement = null) {
  if (lock) {
    lockScroll(menuElement);
  } else {
    unlockScroll();
  }
}
